import { Checkbox, Upload, Typography, Modal, Row, Col, Button, Space, Radio, Card, Input, Select, ColorPicker } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import JoditEditor from "jodit-react";
import axios from 'axios';
import AdminModal from "./AdminModal";
const { confirm } = Modal;
const { TextArea } = Input;
const NewCourseModal = (props) => {
    const [blog_id, set_blog_id] = useState(null);
    useEffect(() => {
        if (JSON.stringify(props.editcard) != '{}') {
            set_blog_id(props.editcard.blog_id);
            // get_picture();

        } else {
            props.setEditCard({ file_id: [], file_url: [] });
            set_blog_id('');
        }
    }, [props.editcard])
    return (
        <>
            <AdminModal
                {...props}
                title={(<>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 25, left: 45 }} >{props.title}</Col>
                    <Col span={24} style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 25 }} >開課介紹</Col>
                    {/* <Col>
                        {props.edit ?
                            <>
                                <Popconfirm
                                    placement="topRight"
                                    title='確定刪除嗎？'
                                    onConfirm={e => props.handleDelete(props.editcard['blog_id'])}
                                    okText="確定"
                                    cancelText="取消"
                                >
                                    <Button style={{ backgroundColor: '#FCF5F6' }} >
                                        <Row>
                                            <Col span={6}>
                                                <img width="80%" src='/cram_school/trashicon.png'></img>
                                            </Col>
                                            <Col span={18}>
                                                <span>刪除貼文</span>
                                            </Col>
                                        </Row>
                                    </Button>
                                </Popconfirm>
                            </> :
                            <>
                            </>
                        }
                    </Col> */}
                </>)}
                uploads
            >
                <Row gutter={[8, 8]} align={'middle'}>
                    <Col span={24}>
                        <Row gutter={8}>
                            <Col span={6}>開課名稱</Col>
                            <Col span={18}>{props.editcard.title}</Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        介紹內文
                    </Col>
                    <Col span={18}>
                        <TextArea rows={4} type='text' value={props.editcard.content} name="content" placeholder="請輸入開課介紹" maxLength={50}
                            autoComplete="off"
                            onChange={e => props.setEditCard(prev => {
                                return (
                                    {
                                        ...prev,
                                        content: e.target.value,
                                    }
                                )
                            })} />
                    </Col>
                    <Col span={6}>背景顏色</Col>
                    <Col span={18}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.background_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            background_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col>
                    <Col span={6}>文字顏色</Col>
                    <Col span={18}>
                        <ColorPicker
                            format={'hex'}
                            value={props.editcard.font_color}
                            onChange={color =>
                                props.setEditCard((pre) => {
                                    return (
                                        {
                                            ...pre,
                                            font_color: `#${color.metaColor.toHex()}`,
                                        }
                                    )
                                })
                            }></ColorPicker>
                    </Col>
                </Row>
            </AdminModal>
        </>
    )
}
export default NewCourseModal;